import { createApp } from "vue";
import store from "@/stores";
import "@/assets/styles/main.scss";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import STable from "@surely-vue/table";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import router from "@/router/index";
import App from "./App.vue";
import dayjs from "dayjs";
import "dayjs/locale/ru";

dayjs.locale("ru");

const app = createApp(App);

app.use(store);
app.use(router);
app.use(Antd);
app.use(STable);

app.mount("#app");
